module.exports = __webpack_public_path__ + "img/section-6-d.b51648f.webp";